/**
 * In-memory registry over nylig opplastet media som ikke er bekreftet servert
 * av backend ennå. `d-media-gallery` registrerer dataUrl-en ved opplastings-
 * tidspunkt, og `d-loading-image` bruker den som placeholder mens den prober
 * den faktiske server-URL-en — så brukeren får umiddelbar visuell feedback i
 * stedet for et sort felt mens upload ↔ HeadObject løper i bakgrunnen.
 *
 * Lever bare i tab/sesjon. Backend er sannhetskilde.
 */
const placeholders = new Map<string, string>();

export function registerLocalPlaceholder(assetUrl: string, dataUrl: string): void {
  placeholders.set(assetUrl, dataUrl);
}

export function getLocalPlaceholder(assetUrl: string): string | undefined {
  return placeholders.get(assetUrl);
}

export function clearLocalPlaceholder(assetUrl: string): void {
  placeholders.delete(assetUrl);
}
